export const PROMPT_LIBRARY = [
    {
        category: 'Buildings',
        prompts: [
            { title: 'Open Building', prompt: 'Open [Building Name]', agentName: 'office' },
            {
                title: 'Get Building Access Info',
                prompt: "What's the access info for [Building]?",
                agentName: 'office'
            },
            {
                title: 'Get Building Contact',
                prompt: "Who's the contact at [Building]?",
                agentName: 'office'
            },
            {
                title: 'List Buildings by Location',
                prompt: 'Which buildings are in [Territory or City]?',
                agentName: 'data'
            },
            {
                title: 'Update Building Address',
                prompt: 'Update the address for [Building]',
                agentName: 'office'
            },
            {
                title: 'Update Building Billing Address',
                prompt: 'Update the billing address for [Building]',
                agentName: 'office'
            }
        ]
    },
    {
        category: 'Contacts',
        prompts: [
            {
                title: 'Get Building Contact',
                prompt: "Who's the contact at [Building]?",
                agentName: 'office'
            },
            {
                title: 'Add Scheduling Contact',
                prompt: 'Add a new scheduling contact to [Building]',
                agentName: 'office'
            },
            {
                title: 'Update Contact Phone Number',
                prompt: 'Update the phone number for [Contact] at [Building]',
                agentName: 'office'
            },
            {
                title: 'Check After-Hours Contact',
                prompt: 'Does [Building] have an after-hours contact on file?',
                agentName: 'office'
            }
        ]
    },
    {
        category: 'Inspections',
        prompts: [
            {
                title: 'Create Annual Inspection',
                prompt: 'Create an annual inspection for [Building]',
                agentName: 'office'
            },
            {
                title: 'List Building Inspections',
                prompt: 'Show me all inspections for [Building]',
                agentName: 'office'
            },
            {
                title: 'Find Technician Inspections',
                prompt: "Find [Technician]'s inspections this month",
                agentName: 'office'
            },
            {
                title: 'Update Inspection Status',
                prompt: 'Change inspection #[Number] status to Completed',
                agentName: 'office'
            },
            {
                title: 'Open Inspection',
                prompt: 'Open inspection #[Number]',
                agentName: 'office'
            },
            {
                title: 'Show Overdue Inspections',
                prompt: 'Show me overdue inspections',
                agentName: 'data'
            },
            {
                title: 'Export Inspection History',
                prompt: 'Export inspection history for [Building] as a spreadsheet',
                agentName: 'data',
                outputType: 'csv'
            }
        ]
    },
    {
        category: 'Devices',
        prompts: [
            {
                title: 'List Building Devices',
                prompt: 'What devices does [Building] have?',
                agentName: 'office'
            },
            {
                title: 'Find Backflow Preventers',
                prompt: 'Find all backflow preventers at [Building]',
                agentName: 'office'
            },
            {
                title: 'List Fire Extinguishers',
                prompt: 'Show me all fire extinguishers for [Account]',
                agentName: 'data'
            },
            {
                title: 'Show Recently Updated Devices',
                prompt: 'Which devices were added or updated in the last 30 days?',
                agentName: 'data'
            },
            {
                title: 'Count Devices by Type',
                prompt: 'How many devices do we have by type across all buildings?',
                agentName: 'data'
            },
            {
                title: 'Find Device by Serial Number',
                prompt: 'Find the device with serial number [Number]',
                agentName: 'office'
            },
            {
                title: 'Show Fire Extinguishers Due for Hydro',
                prompt: 'Which fire extinguishers are due for 12-year hydro in the next 90 days?',
                agentName: 'data'
            },
            {
                title: 'List Alarm Devices',
                prompt: 'Show me all alarm devices at [Building]',
                agentName: 'office'
            }
        ]
    },
    {
        category: 'Work Orders',
        prompts: [
            {
                title: 'Check Work Order Status',
                prompt: "What's the status of work order #[Number]?",
                agentName: 'office'
            },
            {
                title: 'Open Work Order',
                prompt: 'Open work order #[Number]',
                agentName: 'office'
            },
            {
                title: 'List Open Work Orders',
                prompt: 'Show me all open work orders for [Building]',
                agentName: 'office'
            }
        ]
    },
    {
        category: 'Reports & Analytics',
        prompts: [
            {
                title: 'Export Overdue Inspections',
                prompt: 'Show me overdue inspections — export as spreadsheet',
                agentName: 'data',
                outputType: 'csv'
            },
            {
                title: 'Export Inspection History',
                prompt: 'Export inspection history for [Building]',
                agentName: 'data',
                outputType: 'csv'
            },
            {
                title: 'Show Buildings Due for Inspection',
                prompt: 'Which buildings are due for inspection in the next 30 days?',
                agentName: 'data',
                outputType: 'table'
            },
            {
                title: 'Show Deficiency Trends',
                prompt: 'Show deficiency trends over the last 6 months',
                agentName: 'data',
                outputType: 'chart'
            },
            {
                title: 'Chart Deficiency Trends',
                prompt: 'Show deficiency trends — as a chart',
                agentName: 'data',
                outputType: 'chart'
            },
            {
                title: 'Create Overdue Invoice Statement',
                prompt: 'Create a statement of overdue invoices for [Account]',
                agentName: 'data',
                outputType: 'pdf'
            },
            {
                title: 'Show Upcoming Service Dates',
                prompt: 'Show upcoming service dates for [Building or Territory]',
                agentName: 'data',
                outputType: 'table'
            },
            {
                title: 'Generate Backflow Test Report',
                prompt: 'Generate a backflow test report for [Building]',
                agentName: 'data',
                outputType: 'pdf'
            },
            {
                title: 'Show Inspection Series Schedule',
                prompt: 'Show the inspection series schedule for [Building]',
                agentName: 'data',
                outputType: 'table'
            },
            {
                title: 'Compare Monthly Inspections',
                prompt: 'How many inspections did we complete this month vs. last month?',
                agentName: 'data',
                outputType: 'chart'
            },
            {
                title: 'Show Buildings with Most Overdue Inspections',
                prompt: 'Which buildings have the most overdue inspections?',
                agentName: 'data',
                outputType: 'chart'
            },
            {
                title: 'Show Inspection Completions by Technician',
                prompt: 'Show inspection completions by technician this month',
                agentName: 'data',
                outputType: 'chart'
            }
        ]
    }
];
export const TECH_PORTAL_PROMPT_LIBRARY = [
    {
        category: 'Buildings',
        prompts: [
            { title: 'Open Building', prompt: 'Open [Building Name]', agentName: 'office' },
            {
                title: 'Get Building Access Info',
                prompt: "What's the access info for [Building]?",
                agentName: 'office'
            },
            {
                title: 'Get Building Contact',
                prompt: "Who's the contact at [Building]?",
                agentName: 'office'
            }
        ]
    },
    {
        category: 'Contacts',
        prompts: [
            {
                title: 'Get Building Contact',
                prompt: "Who's the contact at [Building]?",
                agentName: 'office'
            },
            {
                title: 'Check After-Hours Contact',
                prompt: 'Does [Building] have an after-hours contact on file?',
                agentName: 'office'
            }
        ]
    },
    {
        category: 'Inspections',
        prompts: [
            {
                title: 'List Building Inspections',
                prompt: 'Show me all inspections for [Building]',
                agentName: 'office'
            },
            {
                title: 'Show my inspections this month',
                prompt: 'Show my inspections this month',
                agentName: 'office'
            },
            {
                title: 'Open Inspection',
                prompt: 'Open inspection #[Number]',
                agentName: 'office'
            }
        ]
    },
    {
        category: 'Devices',
        prompts: [
            {
                title: 'List Building Devices',
                prompt: 'What devices does [Building] have?',
                agentName: 'office'
            },
            {
                title: 'Find Backflow Preventers',
                prompt: 'Find all backflow preventers at [Building]',
                agentName: 'office'
            },
            {
                title: 'Find Device by Serial Number',
                prompt: 'Find the device with serial number [Number]',
                agentName: 'office'
            },
            {
                title: 'List Alarm Devices',
                prompt: 'Show me all alarm devices at [Building]',
                agentName: 'office'
            },
            {
                title: 'List Fire Extinguishers',
                prompt: 'Show me all fire extinguishers for [Account]',
                agentName: 'data'
            }
        ]
    },
    {
        category: 'Work Orders',
        prompts: [
            {
                title: 'Check Work Order Status',
                prompt: "What's the status of work order #[Number]?",
                agentName: 'office'
            },
            {
                title: 'Open Work Order',
                prompt: 'Open work order #[Number]',
                agentName: 'office'
            },
            {
                title: 'List Open Work Orders',
                prompt: 'Show me all open work orders for [Building]',
                agentName: 'office'
            }
        ]
    }
];
